var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipo03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_3414)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.1428,
    cy: 12,
    r: 12,
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.398 9.255H16.298V8.355H15.398V9.255ZM15.398 11.82H16.298V10.92H15.398V11.82ZM15.398 14.37H16.298V13.47H15.398V14.37ZM14.558 16.8V15.9H17.843V6.9H11.918V8.58L11.018 7.95V6H18.743V16.8H14.558ZM5.54297 16.8V10.95L9.60797 8.04L13.658 10.95V16.8H10.403V13.785H8.81297V16.8H5.54297ZM6.44297 15.9H7.91297V12.885H11.303V15.9H12.758V11.415L9.60797 9.15L6.44297 11.415V15.9ZM11.303 15.9V12.885H7.91297V15.9V12.885H11.303V15.9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_3414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.142822)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipo03);
export default __webpack_public_path__ + "static/media/tipo-03.b56c57622023ef5d6d9c5328f3c0e400.svg";
export { ForwardRef as ReactComponent };